module.exports = __webpack_public_path__ + "static/media/facebook-red.354e6e07.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scss/icons/facebook-red.svg
// module id = 900
// module chunks = 0